/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 16.2C13.1667 16.2 14.1583 15.7917 14.975 14.975C15.7917 14.1583 16.2 13.1667 16.2 12C16.2 10.8333 15.7917 9.84168 14.975 9.02501C14.1583 8.20834 13.1667 7.80001 12 7.80001C10.8333 7.80001 9.84168 8.20834 9.02501 9.02501C8.20834 9.84168 7.80001 10.8333 7.80001 12C7.80001 13.1667 8.20834 14.1583 9.02501 14.975C9.84168 15.7917 10.8333 16.2 12 16.2ZM12 21.425C10.7167 21.425 9.50001 21.175 8.35001 20.675C7.20001 20.175 6.20001 19.5 5.35001 18.65C4.50001 17.8 3.82501 16.8042 3.32501 15.6625C2.82501 14.5208 2.57501 13.3 2.57501 12C2.57501 10.7167 2.82501 9.50001 3.32501 8.35001C3.82501 7.20001 4.50001 6.20001 5.35001 5.35001C6.20001 4.50001 7.19584 3.82501 8.33751 3.32501C9.47918 2.82501 10.7 2.57501 12 2.57501C13.2833 2.57501 14.5 2.82501 15.65 3.32501C16.8 3.82501 17.8 4.50001 18.65 5.35001C19.5 6.20001 20.175 7.19584 20.675 8.33751C21.175 9.47918 21.425 10.7 21.425 12C21.425 13.2833 21.175 14.5 20.675 15.65C20.175 16.8 19.5 17.8 18.65 18.65C17.8 19.5 16.8042 20.175 15.6625 20.675C14.5208 21.175 13.3 21.425 12 21.425ZM12 20.325C14.2833 20.325 16.2417 19.5125 17.875 17.8875C19.5083 16.2625 20.325 14.3 20.325 12C20.325 9.71668 19.5083 7.75834 17.875 6.12501C16.2417 4.49168 14.2833 3.67501 12 3.67501C9.70001 3.67501 7.73751 4.49168 6.11251 6.12501C4.48751 7.75834 3.67501 9.71668 3.67501 12C3.67501 14.3 4.48751 16.2625 6.11251 17.8875C7.73751 19.5125 9.70001 20.325 12 20.325Z" fill="#262626" />
  </svg>
);

export default SvgComponent;
